import React, { ReactNode } from 'react'
import { HelpCircle } from 'lucide-react'
import { Tooltip } from 'antd'

type BoxContentProps = {
  children: ReactNode,
  title?: string,
  style?: string,
  titleStyle?: string,
  helperTitle?: string | null
}

export function BoxContent({ children, title, style, titleStyle, helperTitle = null }: BoxContentProps) {
  return (
    <div className={`relative border border-solid border-gray-300 rounded-lg p-[16px] ${style}`}>
      {title && (
        <span
          className={
            titleStyle
              ? titleStyle
              : 'absolute top-[-12px] left-[20px] font-bold bg-white px-[10px] z-20'
          }
        >
          <span className="flex items-center gap-1">
            {title}
            {helperTitle && (
              <Tooltip title={helperTitle}>
                <HelpCircle size={16} className="text-gray-500 cursor-help" />
              </Tooltip>
            )}
          </span>
        </span>
      )}
      {children}
    </div>
  )
}